import { Box, getAccordionDetailsUtilityClass } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  ImageSuiteRequestData,
  useGenerateRandomPrompt,
  useImageSuiteGetImageSettings,
  useImproveImageSuitePrompt,
} from "../../../store/Apis/SuitesApps/ImageSuitesApi";
import {
  ImageAppHistoryItem,
  ImageSettings,
  ImageSuitApps,
  imageSuiteAppInitStates,
  ImageSuiteApps,
  ImageSuiteSample,
  ImageSuiteType,
  MessageType,
  ModelImageDall_EName,
  ModelImageFluxName,
  ModelImageGptImageName,
  ModelImageStabilityName,
} from "../../../Helper";
import SignalRService from "../../one-query/services/SignalRService";
import { setFileError } from "../../../store/one-query/chatsSlice";
import { ImageGeneratorApp } from "../Components/Apps/ImageGeneratorApp";
import { useAppDispatch } from "../../../store/hooks";
import { ExpandGeneratedImageModal } from "../Components/Shared/ExpandGeneratedImageModal";
import { LogoGeneratorApp } from "../Components/Apps/LogoGeneratorApp";
import { IconGeneratorApp } from "../Components/Apps/IconGeneratorApp";
import { IllustrationGeneratorApp } from "../Components/Apps/IllustrationGeneratorApp";
import { BackgroundRemoverApp } from "../Components/Apps/BackgroundRemoverApp";
import { ImageRestoreApp } from "../Components/Apps/ImageRestoreApp";
import { ActiveItemInterface } from "../../TextSuite/Views/TextSuiteSidebar";
import { GenerateImageSuiteItem, imageSuiteModel } from "../../../Types/ImageSuite-types";
import { MicroPeopleApp } from "../Components/Apps/MicroPeopleApp";
import { TinyFiguresApp } from "../Components/Apps/TinyFiguresApp";
import { useGetUserCredits } from "../../../store/Apis/StripeApi";
import { getVideoSuiteType } from "../../../Types/VideoSuite-Types";
import { setMessageErrorAppSuite } from "../../../store/account/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { getBaseUrl } from "../Helper";
import { ImageToImageApp } from "../Components/Apps/ImageToImageApp";

interface GenerationViewProps {
  activeItem: ActiveItemInterface;
  ImageSuiteSamples: ImageSuiteSample[];
}
export const ImageSuiteContainer = ({
  activeItem,
  ImageSuiteSamples,
}: GenerationViewProps) => {
  const location = useLocation();
  const {
    refetch: GetImageSettings,
    isSuccess: IsImageSettingsSuccess,
    data: ImageSettingsData,
  } = useImageSuiteGetImageSettings();
  const { mutate: GenerateRandomPrompt, isPending: IsGeneratePromptLoading } =
    useGenerateRandomPrompt();
  const {
    mutate: ImproveImagePromptRequest,
    isPending: isImagePromptImproving,
  } = useImproveImageSuitePrompt();
  const hasRedirectApp = location?.state?.activeImageAppData;

  const dispatch = useAppDispatch();
  const getUserCredits = useGetUserCredits();
  const [isFinished, setIsFinished] = useState(false);
  const [expandImage, setExpandImage] = useState(false);
  const [imageSettings, setImageSettings] = useState<ImageSettings>({
    imageModels: [],
    imageDimensions: [],
    seed: null,
  });
  const [generatedPrompt, setGeneratedPrompt] = useState("");
  const [suggestionAppData, setSuggestionAppData] =
    useState<ImageAppHistoryItem>();
  const navigate = useNavigate();

  const [generateImageSuites, setGenerateImageSuites] = useState<{
    ImageGenerator: GenerateImageSuiteItem;
    LogoGenerator: GenerateImageSuiteItem;
    IconGenerator: GenerateImageSuiteItem;
    IllustrationGenerator: GenerateImageSuiteItem;
    TinyFigures: GenerateImageSuiteItem;
    MicroPeople: GenerateImageSuiteItem;
    BackgroundRemover: GenerateImageSuiteItem;
    ImageRestore: GenerateImageSuiteItem;
    ImageToImage: GenerateImageSuiteItem;
  }>(imageSuiteAppInitStates);

  const getActiveAppObj = useMemo(() => {
    switch (activeItem.type) {
      case ImageSuitApps.ImageGenerator:
        return generateImageSuites.ImageGenerator;
      case ImageSuitApps.LogoGenerator:
        return generateImageSuites.LogoGenerator;
      case ImageSuitApps.IconGenerator:
        return generateImageSuites.IconGenerator;
      case ImageSuitApps.IllustrationGenerator:
        return generateImageSuites.IllustrationGenerator;
      case ImageSuitApps.BackGroundRemover:
        return generateImageSuites.BackgroundRemover;
      case ImageSuitApps.ImageRestore:
        return generateImageSuites.ImageRestore;
      case ImageSuitApps.MicroPeople:
        return generateImageSuites.MicroPeople;
      case ImageSuitApps.TinyFigures:
        return generateImageSuites.TinyFigures;
      case ImageSuitApps.ImageToImage:
        return generateImageSuites.ImageToImage;
      default:
        return null;
    }
  }, [activeItem, generateImageSuites]);

  useEffect(() => {
    ImageSuiteSamples?.forEach((item: ImageSuiteSample) => {
      if (item.type === ImageSuiteType.ImageGenerator) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          ImageGenerator: {
            ...prevState.ImageGenerator,
            example: {
              ...item,
            },
          },
        }));
      } else if (item.type === ImageSuiteType.LogoGenerator) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          LogoGenerator: {
            ...prevState.LogoGenerator,
            example: {
              ...item,
            },
          },
        }));
      } else if (item.type === ImageSuiteType.IconGenerator) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          IconGenerator: {
            ...prevState.IconGenerator,
            example: {
              ...item,
            },
          },
        }));
      } else if (item.type === ImageSuiteType.IllustrationGenerator) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          IllustrationGenerator: {
            ...prevState.IllustrationGenerator,
            example: {
              ...item,
            },
          },
        }));
      } else if (item.type === ImageSuiteType.BackGroundRemover) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          BackgroundRemover: {
            ...prevState.BackgroundRemover,
            example: {
              ...item,
            },
          },
        }));
      } else if (item.type === ImageSuiteType.ImageRestore) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          ImageRestore: {
            ...prevState.ImageRestore,
            example: {
              ...item,
            },
          },
        }));
      } else if (item.type === ImageSuitApps.MicroPeople) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          MicroPeople: {
            ...prevState.MicroPeople,
            example: {
              ...item,
            },
          },
        }));
      } else if (item.type === ImageSuitApps.TinyFigures) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          TinyFigures: {
            ...prevState.TinyFigures,
            example: {
              ...item,
            },
          },
        }));
      } else if (item.type === ImageSuitApps.ImageToImage) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          ImageToImage: {
            ...prevState.ImageToImage,
            example: {
              ...item,
            },
          },
        }));
      }
    });
  }, [ImageSuiteSamples]);

  const handleOpenExpandImage = () => {
    setExpandImage(true);
  };

  const handleCloseExpandImage = () => {
    setExpandImage(false);
  };

  useEffect(() => {
    GetImageSettings();
  }, []);

  const getErrorMessage = (error: any) => {
    const responseData = error?.response?.data;
    if (responseData) {
      dispatch(setMessageErrorAppSuite(responseData));
    }
  };
  useEffect(() => {
    const randomValue = Math.floor(Math.random() * 1000000 + 1);
    const CreditsNeededForGPT=ImageSettingsData?.imageModels?.find((model:any)=>model?.modelVersion==="gpt-image-1")?.creditsNeeded
    const CreditsNeededForFlux=ImageSettingsData?.imageModels?.find((model:any)=>model?.modelVersion==="Flux")?.creditsNeeded
   
    if (IsImageSettingsSuccess && ImageSettingsData) {
      setImageSettings(ImageSettingsData);
      setGenerateImageSuites((prevState) => ({
        ...prevState,
        ImageGenerator: {
          ...prevState.ImageGenerator,
          selectedModel: ImageSettingsData.imageModels[0].modelVersion || "",
          creditsNeeded:ImageSettingsData?.imageModels[0]?.creditsNeeded || null,
          selectedSize: ImageSettingsData.imageDimensions[0] || "",
          seed: randomValue,
        },
        LogoGenerator: {
          ...prevState.LogoGenerator,
          selectedModel: ImageSettingsData.imageModels[0].modelVersion || "",
          creditsNeeded:ImageSettingsData?.imageModels[0]?.creditsNeeded || null,
          selectedSize: ImageSettingsData.imageDimensions[0] || "",
          seed: randomValue,
        },
        IconGenerator: {
          ...prevState.IconGenerator,
          selectedModel: ImageSettingsData.imageModels[0].modelVersion || "",
          creditsNeeded:ImageSettingsData?.imageModels[0]?.creditsNeeded || null,
          selectedSize: ImageSettingsData.imageDimensions[0] || "",
          seed: randomValue,
        },
        IllustrationGenerator: {
          ...prevState.IllustrationGenerator,
          selectedModel: ImageSettingsData.imageModels[0].modelVersion || "",
          creditsNeeded:ImageSettingsData?.imageModels[0]?.creditsNeeded || null,
          selectedSize: ImageSettingsData.imageDimensions[0] || "",
          seed: randomValue,
        },
        BackgroundRemover: {
          ...prevState.BackgroundRemover,
          creditsNeeded:CreditsNeededForFlux,
        },
        ImageRestore: {
          ...prevState.ImageRestore,
          selectedModel: ImageSettingsData.imageModels[0].modelVersion || "",
          selectedSize: ImageSettingsData.imageDimensions[0] || "",
          creditsNeeded:CreditsNeededForFlux,
          seed: randomValue,
        },
        MicroPeople: {
          ...prevState.MicroPeople,
          selectedModel:
            ImageSettingsData.imageModels.find(
              (m: any) =>
                m.modelName === ModelImageGptImageName
            )?.modelVersion || "",
          selectedSize: ImageSettingsData.imageDimensions[0] || "",
          creditsNeeded:ImageSettingsData?.imageModels[0]?.creditsNeeded || null,
          seed: randomValue,
        },
        TinyFigures: {
          ...prevState.TinyFigures,
          selectedModel: ImageSettingsData.imageModels[0].modelVersion || "",
          selectedSize: ImageSettingsData.imageDimensions[0] || "",
          creditsNeeded:ImageSettingsData?.imageModels[0]?.creditsNeeded || null,
          seed: randomValue,
        },
        ImageToImage: {
          ...prevState.ImageToImage,
          selectedModel: "",
          selectedSize: ImageSettingsData.imageDimensions[0] || "",
          creditsNeeded:CreditsNeededForGPT
        },
      }));
    }
  }, [ImageSettingsData, IsImageSettingsSuccess]);

  const onResultFinished = () => {
    getUserCredits();
  };

  useEffect(() => {
    if (isFinished) {
      setIsFinished(false);
      setGeneratedPrompt("");
      setGenerateImageSuites((prevState) => {
        const newState = { ...prevState };
        switch (activeItem.type) {
          case ImageSuitApps.ImageGenerator:
            newState.ImageGenerator.isLoading = false;
            break;
          case ImageSuitApps.LogoGenerator:
            newState.LogoGenerator.isLoading = false;
            break;
          case ImageSuitApps.IconGenerator:
            newState.IconGenerator.isLoading = false;
            break;
          case ImageSuitApps.IllustrationGenerator:
            newState.IllustrationGenerator.isLoading = false;
            break;
          case ImageSuitApps.BackGroundRemover:
            newState.BackgroundRemover.isLoading = false;
            break;
          case ImageSuitApps.ImageRestore:
            newState.ImageRestore.isLoading = false;
            break;
          case ImageSuitApps.MicroPeople:
            newState.MicroPeople.isLoading = false;
            break;
          case ImageSuitApps.TinyFigures:
            newState.TinyFigures.isLoading = false;
            break;
          case ImageSuitApps.ImageToImage:
            newState.ImageToImage.isLoading = false;
            break;
          default:
            break;
        }
        return newState;
      });
      onResultFinished();
    }
  }, [isFinished]);

  const handleGenerateImageSuitesSignalR = useCallback(
    (
      modelName: string,
      modelVersion: string,
      message: string,
      tag: string,
      conversationId: string,
      messageId: string,
      messageType: number
    ) => {
      console.log("message messageType", messageType);
      console.log("message", message);

      if (message === "**/**Finished**/**") {
        setIsFinished(true);
      } else {
        if (messageType === MessageType.ImageSuiteGenerateImage) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            ImageGenerator: {
              ...prevState.ImageGenerator,
              output: getBaseUrl(message),
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteGenerateLogo) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            LogoGenerator: {
              ...prevState.LogoGenerator,
              output: getBaseUrl(message),
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteGenerateIcon) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            IconGenerator: {
              ...prevState.IconGenerator,
              output: getBaseUrl(message),
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteGenerateIllustration) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            IllustrationGenerator: {
              ...prevState.IllustrationGenerator,
              output: getBaseUrl(message),
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteBackgroundRemover) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            BackgroundRemover: {
              ...prevState.BackgroundRemover,
              output: getBaseUrl(message),
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteRestoreImage) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            ImageRestore: {
              ...prevState.ImageRestore,
              output: getBaseUrl(message),
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteMicroPeople) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            MicroPeople: {
              ...prevState.MicroPeople,
              output: getBaseUrl(message),
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteTinyFigures) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            TinyFigures: {
              ...prevState.TinyFigures,
              output: getBaseUrl(message),
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteImageToImage) {
          setGenerateImageSuites((prevState) => ({
            ...prevState,
            ImageToImage: {
              ...prevState.ImageToImage,
              output: window?.location?.origin + message,
              isLoading: true,
            },
          }));
        } else if (messageType === MessageType.ImageSuiteError) {
          dispatch(
            setFileError({
              isError: true,
              errorMsg: message,
              reason: message,
            })
          );
        } else if (messageType === MessageType.Utility && message !== null) {
          setGeneratedPrompt((prev) => (prev ? prev + message : message));
        }
      }
    },
    []
  );

  const setupSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("SendModelMessage", handleGenerateImageSuitesSignalR);
    return () => {
      connection.off("SendModelMessage", handleGenerateImageSuitesSignalR);
    };
  }, [handleGenerateImageSuitesSignalR]);

  useEffect(() => {
    const cleanup = setupSignalRConnection();
    return () => {
      cleanup();
    };
  }, [setupSignalRConnection]);

  // ==============================================================

  // signalR to replace old image url with new AzureImage url, firts for performance BE save image locally,
  //  then to azure, after azure finish we remove drive image and replace it ith azure.
  const handleReplaceImageURL = useCallback(
    (
      messageId: string,
      responseId: string,
      oldImageUrl: string,
      newImageUrl: string,
      messageType: number
    ) => {
      if (messageType === MessageType.ImageSuiteGenerateImage) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          ImageGenerator: {
            ...prevState.ImageGenerator,
            output: newImageUrl,
          },
        }));
      } else if (messageType === MessageType.ImageSuiteGenerateLogo) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          LogoGenerator: {
            ...prevState.LogoGenerator,
            output: newImageUrl,
          },
        }));
      } else if (messageType === MessageType.ImageSuiteGenerateIcon) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          IconGenerator: {
            ...prevState.IconGenerator,
            output: newImageUrl,
          },
        }));
      } else if (messageType === MessageType.ImageSuiteGenerateIllustration) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          IllustrationGenerator: {
            ...prevState.IllustrationGenerator,
            output: newImageUrl,
          },
        }));
      } else if (messageType === MessageType.ImageSuiteBackgroundRemover) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          BackgroundRemover: {
            ...prevState.BackgroundRemover,
            output: newImageUrl,
          },
        }));
      } else if (messageType === MessageType.ImageSuiteRestoreImage) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          ImageRestore: {
            ...prevState.ImageRestore,
            output: newImageUrl,
          },
        }));
      } else if (messageType === MessageType.ImageSuiteMicroPeople) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          MicroPeople: {
            ...prevState.MicroPeople,
            output: newImageUrl,
          },
        }));
      } else if (messageType === MessageType.ImageSuiteTinyFigures) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          TinyFigures: {
            ...prevState.TinyFigures,
            output: newImageUrl,
          },
        }));
      } else if (messageType === MessageType.ImageSuiteImageToImage) {
        setGenerateImageSuites((prevState) => ({
          ...prevState,
          ImageToImage: {
            ...prevState.ImageToImage,
            output: newImageUrl,
          },
        }));
      }
    },
    []
  );

  const replaceURLImageSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("ReplaceOldImageUrl", handleReplaceImageURL);
    return () => {
      connection.off("ReplaceOldImageUrl", handleReplaceImageURL);
    };
  }, [handleGenerateImageSuitesSignalR]);

  useEffect(() => {
    const cleanup = replaceURLImageSignalRConnection();
    return () => {
      cleanup();
    };
  }, [replaceURLImageSignalRConnection]);

  const handelGenerateRandomPrompt = async () => {
    setGeneratedPrompt("");
    const connectionId = await SignalRService.getInstance().getConnectionId();
    const RequestData = {
      connectionId: connectionId,
      type: getVideoSuiteType() + "",
    };
    GenerateRandomPrompt(RequestData);
  };

  const handleSelectGenerateImageModel = (model: string) => {
      var imageModels = ImageSettingsData?.imageModels as imageSuiteModel[];
      const creditsNeededForModel = imageModels.find(e => e.modelVersion===model)?.creditsNeeded
    setGenerateImageSuites((prevState) => {
      const newState = { ...prevState };
      switch (activeItem.type) {
        case ImageSuitApps.ImageGenerator:
          newState.ImageGenerator.selectedModel = model;
          newState.ImageGenerator.creditsNeeded = creditsNeededForModel;
          break;
        case ImageSuitApps.LogoGenerator:
          newState.LogoGenerator.selectedModel = model;
          newState.LogoGenerator.creditsNeeded = creditsNeededForModel;
          break;
        case ImageSuitApps.IconGenerator:
          newState.IconGenerator.selectedModel = model;
          newState.IconGenerator.creditsNeeded = creditsNeededForModel;
          break;
        case ImageSuitApps.IllustrationGenerator:
          newState.IllustrationGenerator.selectedModel = model;
          newState.IllustrationGenerator.creditsNeeded = creditsNeededForModel;
          break;
        case ImageSuitApps.BackGroundRemover:
          newState.BackgroundRemover.selectedModel = model;
          newState.BackgroundRemover.creditsNeeded = creditsNeededForModel;
          break;
        case ImageSuitApps.ImageRestore:
          newState.ImageRestore.selectedModel = model;
          newState.ImageRestore.creditsNeeded = creditsNeededForModel;
        case ImageSuitApps.MicroPeople:
          newState.MicroPeople.selectedModel = model;
          newState.MicroPeople.creditsNeeded = creditsNeededForModel;
          break;
        case ImageSuitApps.TinyFigures:
          newState.TinyFigures.selectedModel = model;
          newState.TinyFigures.creditsNeeded = creditsNeededForModel;
          break;
        case ImageSuitApps.ImageToImage:
          newState.ImageToImage.selectedModel = model;
          newState.ImageToImage.creditsNeeded = creditsNeededForModel;
          break;
        default:
          break;
      }
      return newState;
    });
  };
  const toggleLockSeed = (openLockSeed: boolean) => {
    setGenerateImageSuites((prevState) => {
      const newState = { ...prevState };
      switch (activeItem.type) {
        case ImageSuitApps.ImageGenerator:
          newState.ImageGenerator.openLockSeed = openLockSeed;
          break;
        case ImageSuitApps.LogoGenerator:
          newState.LogoGenerator.openLockSeed = openLockSeed;
          break;
        case ImageSuitApps.IconGenerator:
          newState.IconGenerator.openLockSeed = openLockSeed;
          break;
        case ImageSuitApps.IllustrationGenerator:
          newState.IllustrationGenerator.openLockSeed = openLockSeed;
          break;
        case ImageSuitApps.TinyFigures:
          newState.TinyFigures.openLockSeed = openLockSeed;
          break;
        case ImageSuitApps.ImageToImage:
          newState.ImageToImage.openLockSeed = openLockSeed;
          break;
        default:
          break;
      }
      return newState;
    });
  };

  const handleSelectGenerateImageSize = (size: string) => {
    setGenerateImageSuites((prevState) => {
      const newState = { ...prevState };
      switch (activeItem.type) {
        case ImageSuitApps.ImageGenerator:
          newState.ImageGenerator.selectedSize = size;
          break;
        case ImageSuitApps.LogoGenerator:
          newState.LogoGenerator.selectedSize = size;
          break;
        case ImageSuitApps.IconGenerator:
          newState.IconGenerator.selectedSize = size;
          break;
        case ImageSuitApps.IllustrationGenerator:
          newState.IllustrationGenerator.selectedSize = size;
          break;
        case ImageSuitApps.BackGroundRemover:
          newState.BackgroundRemover.selectedSize = size;
          break;
        case ImageSuitApps.ImageRestore:
          newState.ImageRestore.selectedSize = size;
          break;
        case ImageSuitApps.MicroPeople:
          newState.MicroPeople.selectedSize = size;
          break;
        case ImageSuitApps.TinyFigures:
          newState.TinyFigures.selectedSize = size;
          break;
        case ImageSuitApps.ImageToImage:
          newState.ImageToImage.selectedSize = size;
          break;
        default:
          break;
      }
      return newState;
    });
  };

  const handleUpdateInputValue = (value: string) => {
    setGenerateImageSuites((prevState) => {
      const newState = { ...prevState };
      switch (activeItem.type) {
        case ImageSuitApps.ImageGenerator:
          newState.ImageGenerator.inputValue = value;
          break;
        case ImageSuitApps.LogoGenerator:
          newState.LogoGenerator.inputValue = value;
          break;
        case ImageSuitApps.IconGenerator:
          newState.IconGenerator.inputValue = value;
          break;
        case ImageSuitApps.IllustrationGenerator:
          newState.IllustrationGenerator.inputValue = value;
          break;
        case ImageSuitApps.MicroPeople:
          newState.MicroPeople.inputValue = value;
          break;
        case ImageSuitApps.TinyFigures:
          newState.TinyFigures.inputValue = value;
          break;
        case ImageSuitApps.ImageToImage:
          newState.ImageToImage.inputValue = value;
          break;
        default:
          break;
      }
      return newState;
    });
  };

  const handleInputImageChange = (image: File | string | null) => {
    setGenerateImageSuites((prevState) => {
      const newState = { ...prevState };
      switch (activeItem.type) {
        case ImageSuitApps.BackGroundRemover:
          newState.BackgroundRemover.inputValue = image;
          break;
        case ImageSuitApps.ImageRestore:
          newState.ImageRestore.inputValue = image;
          break;
        case ImageSuitApps.ImageToImage:
          newState.ImageToImage.inputImageValue = image;
          break;
        case ImageSuitApps.MicroPeople:
          newState.MicroPeople.inputImageValue = image;
          break;
        default:
          break;
      }
      return newState;
    });
  };

  const handleClearInput = () => {
    handleInputImageChange(null);
    setGenerateImageSuites((prevState) => {
      const newState = { ...prevState };
      switch (activeItem.type) {
        case ImageSuitApps.BackGroundRemover:
          newState.BackgroundRemover.inputValue = "";
          break;
        case ImageSuitApps.ImageRestore:
          newState.ImageRestore.inputValue = "";
          break;
        case ImageSuitApps.ImageToImage:
          newState.ImageToImage.inputImageValue = "";
          break;
        case ImageSuitApps.MicroPeople:
          newState.MicroPeople.inputImageValue = "";
          break;
        default:
          break;
      }
      return newState;
    });
  };

  const handleSetIsLoading = (isLoading: boolean) => {
    setGenerateImageSuites((prevState) => {
      const newState = { ...prevState };
      switch (activeItem.type) {
        case ImageSuitApps.ImageGenerator:
          newState.ImageGenerator.isLoading = isLoading;
          break;
        case ImageSuitApps.LogoGenerator:
          newState.LogoGenerator.isLoading = isLoading;
          break;
        case ImageSuitApps.IconGenerator:
          newState.IconGenerator.isLoading = isLoading;
          break;
        case ImageSuitApps.IllustrationGenerator:
          newState.IllustrationGenerator.isLoading = isLoading;
          break;
        case ImageSuitApps.BackGroundRemover:
          newState.BackgroundRemover.isLoading = isLoading;
          break;
        case ImageSuitApps.ImageRestore:
          newState.ImageRestore.isLoading = isLoading;
          break;
        case ImageSuitApps.MicroPeople:
          newState.MicroPeople.isLoading = isLoading;
          break;
        case ImageSuitApps.TinyFigures:
          newState.TinyFigures.isLoading = isLoading;
          break;
        case ImageSuitApps.ImageToImage:
          newState.ImageToImage.isLoading = isLoading;
          break;
        default:
          break;
      }
      return newState;
    });
  };

  // Get current suggestion app data.
  useEffect(() => {
    if (location.state && location.state.imageSuiteAppData) {
      let suggestionData = location.state.imageSuiteAppData;
      setGenerateImageSuites((prevState) => {
        const newState = { ...prevState };
        switch (location.state.imageSuiteAppName) {
          case ImageSuiteApps.ImageGenerator:
            newState.ImageGenerator.suggestionAppData = suggestionData;
            break;
          case ImageSuiteApps.LogoGenerator:
            newState.LogoGenerator.suggestionAppData = suggestionData;
            break;
          case ImageSuiteApps.IconGenerator:
            newState.IconGenerator.suggestionAppData = suggestionData;
            break;
          case ImageSuiteApps.IllustrationGenerator:
            newState.IllustrationGenerator.suggestionAppData = suggestionData;
            break;
          case ImageSuiteApps.BackgroundRemover:
            newState.BackgroundRemover.suggestionAppData = suggestionData;
            break;
          case ImageSuiteApps.ImageRestore:
            newState.ImageRestore.suggestionAppData = suggestionData;
            break;
          case ImageSuiteApps.MicroPeople:
            newState.MicroPeople.suggestionAppData = suggestionData;
            break;
          case ImageSuiteApps.TinyFigures:
            newState.TinyFigures.suggestionAppData = suggestionData;
            break;
          case ImageSuiteApps.ImageToImage:
            newState.ImageToImage.suggestionAppData = suggestionData;
            break;
          default:
            break;
        }
        return newState;
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [activeItem]);

  const handelImprovePrompt = async () => {
    const connectionId = await SignalRService.getInstance().getConnectionId();
    if (getActiveAppObj?.inputValue) {
      const improvePromptRequestData = {
        prompt: getActiveAppObj?.inputValue,
        connectionId: connectionId,
      };
      ImproveImagePromptRequest(improvePromptRequestData);
    }
  };

  // Handle image library data if available.
  useEffect(() => {
    if (hasRedirectApp) {
     setGenerateImageSuites((prevState) => ({
          ...prevState,
          ImageGenerator: {
            ...prevState.ImageGenerator,
            inputValue: hasRedirectApp?.prompt,
            input: hasRedirectApp?.prompt,
            output: hasRedirectApp?.url,
          },
      }));
    }
  } ,[hasRedirectApp])

  return (
    <>
      <Box className="generation-view">
        {getActiveAppObj?.type === ImageSuitApps.ImageGenerator ? (
          <ImageGeneratorApp
            imageSettings={imageSettings}
            generatedPrompt={generatedPrompt}
            generatedImg={getActiveAppObj.output}
            setInputValue={handleUpdateInputValue}
            handleSetIsLoading={handleSetIsLoading}
            inputValue={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            selectedSize={getActiveAppObj.selectedSize}
            creditsNeeded={getActiveAppObj.creditsNeeded||null}
            seed={getActiveAppObj?.seed ?? null}
            openLockSeed={getActiveAppObj.openLockSeed ?? false}
            handleOpenExpandImage={handleOpenExpandImage}
            selectedModel={getActiveAppObj.selectedModel}
            setSelectedSize={handleSelectGenerateImageSize}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            setSelectedModel={handleSelectGenerateImageModel}
            toggleLockSeed={toggleLockSeed}
            getErrorMessage={getErrorMessage}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            handelGenerateRandomPrompt={handelGenerateRandomPrompt}
            handelImprovePrompt={handelImprovePrompt}
            isImagePromptImproving={isImagePromptImproving}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : getActiveAppObj?.type === ImageSuitApps.LogoGenerator ? (
          <LogoGeneratorApp
            imageSettings={imageSettings}
            generatedPrompt={generatedPrompt}
            generatedImg={getActiveAppObj.output}
            setInputValue={handleUpdateInputValue}
            inputValue={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            creditsNeeded={getActiveAppObj.creditsNeeded || null}
            handleSetIsLoading={handleSetIsLoading}
            selectedSize={getActiveAppObj.selectedSize}
            seed={getActiveAppObj?.seed ?? null}
            toggleLockSeed={toggleLockSeed}
            openLockSeed={getActiveAppObj.openLockSeed ?? false}
            selectedModel={getActiveAppObj.selectedModel}
            handleOpenExpandImage={handleOpenExpandImage}
            setSelectedSize={handleSelectGenerateImageSize}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            setSelectedModel={handleSelectGenerateImageModel}
            getErrorMessage={getErrorMessage}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            handelGenerateRandomPrompt={handelGenerateRandomPrompt}
            handelImprovePrompt={handelImprovePrompt}
            isImagePromptImproving={isImagePromptImproving}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : getActiveAppObj?.type === ImageSuitApps.IconGenerator ? (
          <IconGeneratorApp
            imageSettings={imageSettings}
            generatedPrompt={generatedPrompt}
            generatedImg={getActiveAppObj.output}
            setInputValue={handleUpdateInputValue}
            inputValue={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            creditsNeeded={getActiveAppObj.creditsNeeded || null}
            handleSetIsLoading={handleSetIsLoading}
            selectedSize={getActiveAppObj.selectedSize}
            seed={getActiveAppObj?.seed ?? null}
            toggleLockSeed={toggleLockSeed}
            openLockSeed={getActiveAppObj.openLockSeed ?? false}
            handleOpenExpandImage={handleOpenExpandImage}
            selectedModel={getActiveAppObj.selectedModel}
            getErrorMessage={getErrorMessage}
            setSelectedSize={handleSelectGenerateImageSize}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            setSelectedModel={handleSelectGenerateImageModel}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            handelGenerateRandomPrompt={handelGenerateRandomPrompt}
            handelImprovePrompt={handelImprovePrompt}
            isImagePromptImproving={isImagePromptImproving}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : getActiveAppObj?.type === ImageSuitApps.IllustrationGenerator ? (
          <IllustrationGeneratorApp
            imageSettings={imageSettings}
            generatedPrompt={generatedPrompt}
            generatedImg={getActiveAppObj.output}
            inputValue={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            creditsNeeded={getActiveAppObj.creditsNeeded||null}
            setInputValue={handleUpdateInputValue}
            handleSetIsLoading={handleSetIsLoading}
            selectedSize={getActiveAppObj.selectedSize}
            seed={getActiveAppObj?.seed ?? null}
            openLockSeed={getActiveAppObj.openLockSeed ?? false}
            toggleLockSeed={toggleLockSeed}
            handleOpenExpandImage={handleOpenExpandImage}
            getErrorMessage={getErrorMessage}
            selectedModel={getActiveAppObj.selectedModel}
            setSelectedSize={handleSelectGenerateImageSize}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            setSelectedModel={handleSelectGenerateImageModel}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            handelGenerateRandomPrompt={handelGenerateRandomPrompt}
            handelImprovePrompt={handelImprovePrompt}
            isImagePromptImproving={isImagePromptImproving}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : getActiveAppObj?.type === ImageSuitApps.BackGroundRemover ? (
          <BackgroundRemoverApp
            imageSettings={imageSettings}
            input={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            creditsNeeded={getActiveAppObj.creditsNeeded||null}
            handleClearInput={handleClearInput}
            generatedImg={getActiveAppObj.output}
            getErrorMessage={getErrorMessage}
            handleSetIsLoading={handleSetIsLoading}
            handleOpenExpandImage={handleOpenExpandImage}
            handleInputImageChange={handleInputImageChange}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            selectedModel={getActiveAppObj.selectedModel}
            setSelectedModel={handleSelectGenerateImageModel}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : getActiveAppObj?.type === ImageSuitApps.ImageRestore ? (
          <ImageRestoreApp
            input={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            handleClearInput={handleClearInput}
            generatedImg={getActiveAppObj.output}
            creditsNeeded={getActiveAppObj.creditsNeeded||null}
            handleSetIsLoading={handleSetIsLoading}
            getErrorMessage={getErrorMessage}
            handleOpenExpandImage={handleOpenExpandImage}
            handleInputImageChange={handleInputImageChange}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : getActiveAppObj?.type === ImageSuitApps.MicroPeople ? (
          <MicroPeopleApp
            imageSettings={imageSettings}
            generatedPrompt={generatedPrompt}
            generatedImg={getActiveAppObj.output}
            setInputValue={handleUpdateInputValue}
            handleSetIsLoading={handleSetIsLoading}
            creditsNeeded={getActiveAppObj.creditsNeeded||null}
            inputValue={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            getErrorMessage={getErrorMessage}
            selectedSize={getActiveAppObj.selectedSize}
            seed={getActiveAppObj?.seed ?? null}
            openLockSeed={getActiveAppObj.openLockSeed ?? false}
            toggleLockSeed={toggleLockSeed}
            handleOpenExpandImage={handleOpenExpandImage}
            selectedModel={getActiveAppObj.selectedModel}
            setSelectedSize={handleSelectGenerateImageSize}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            setSelectedModel={handleSelectGenerateImageModel}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            handelGenerateRandomPrompt={handelGenerateRandomPrompt}
            handleClearInput={handleClearInput}
            handleInputImageChange={handleInputImageChange}
            inputImageValue={getActiveAppObj.inputImageValue}
            handelImprovePrompt={handelImprovePrompt}
            isImagePromptImproving={isImagePromptImproving}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : getActiveAppObj?.type === ImageSuitApps.TinyFigures ? (
          <TinyFiguresApp
            imageSettings={imageSettings}
            generatedPrompt={generatedPrompt}
            generatedImg={getActiveAppObj.output}
            setInputValue={handleUpdateInputValue}
            handleSetIsLoading={handleSetIsLoading}
            creditsNeeded={getActiveAppObj.creditsNeeded||null}
            inputValue={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            getErrorMessage={getErrorMessage}
            selectedSize={getActiveAppObj.selectedSize}
            seed={getActiveAppObj?.seed ?? null}
            openLockSeed={getActiveAppObj.openLockSeed ?? false}
            toggleLockSeed={toggleLockSeed}
            handleOpenExpandImage={handleOpenExpandImage}
            selectedModel={getActiveAppObj.selectedModel}
            setSelectedSize={handleSelectGenerateImageSize}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            setSelectedModel={handleSelectGenerateImageModel}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            handelGenerateRandomPrompt={handelGenerateRandomPrompt}
            handelImprovePrompt={handelImprovePrompt}
            isImagePromptImproving={isImagePromptImproving}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : getActiveAppObj?.type === ImageSuitApps.ImageToImage ? (
          <ImageToImageApp
            imageSettings={imageSettings}
            generatedPrompt={generatedPrompt}
            generatedImg={getActiveAppObj.output}
            setInputValue={handleUpdateInputValue}
            creditsNeeded={getActiveAppObj.creditsNeeded||null}
            inputValue={
              getActiveAppObj.suggestionAppData.output ||
              getActiveAppObj.inputValue
            }
            handleSetIsLoading={handleSetIsLoading}
            selectedSize={getActiveAppObj.selectedSize}
            seed={getActiveAppObj?.seed ?? null}
            toggleLockSeed={toggleLockSeed}
            openLockSeed={getActiveAppObj.openLockSeed ?? false}
            selectedModel={getActiveAppObj.selectedModel}
            handleOpenExpandImage={handleOpenExpandImage}
            setSelectedSize={handleSelectGenerateImageSize}
            isGenerateImgLoading={getActiveAppObj.isLoading}
            setSelectedModel={handleSelectGenerateImageModel}
            getErrorMessage={getErrorMessage}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            isGenerateButtonDisabled={getActiveAppObj.isLoading}
            handelGenerateRandomPrompt={handelGenerateRandomPrompt}
            handleClearInput={handleClearInput}
            handleInputImageChange={handleInputImageChange}
            inputImageValue={getActiveAppObj.inputImageValue}
            handelImprovePrompt={handelImprovePrompt}
            isImagePromptImproving={isImagePromptImproving}
            example={{
              ...getActiveAppObj.example,
            }}
          />
        ) : null}
      </Box>
      {expandImage && (
        <ExpandGeneratedImageModal
          open={expandImage}
          imgSrc={getActiveAppObj?.output || getActiveAppObj?.example?.path}
          handleClose={handleCloseExpandImage}
        />
      )}
    </>
  );
};
